module.exports = __webpack_public_path__ + "assets/img/close-icon.904eb71b.png";